import _ from 'lodash';
import React from 'react';

const WEIGHT_LABELS = [
  <span>
    <b>light</b>
- will be applied less often
  </span>,
  <span><b>normal</b></span>,
  <span>
    <b>aggressive</b>
    {' '}
    will be applied often
  </span>,
  <span>
    <b>very aggressive</b>
    {' '}
    will be applied more often
  </span>,
  <span>
    <b>extremely aggressive</b>
    {' '}
    will be applied very often
  </span>,
];

export default function (weight = 0) {
  return WEIGHT_LABELS[weight] || _.last(WEIGHT_LABELS);
}
